// extracted by mini-css-extract-plugin
export default {"edit":"edit___cRQf3Fr","wrap":"wrap___cRQf3Fr","fullWidth":"fullWidth___cRQf3Fr"};